module.exports = __webpack_public_path__ + "static/media/Group.240ec106.png";